import { cn } from '@/utils/cn';

type BarColor = 'ember' | 'mystic' | 'moss';

const COLORS: Record<BarColor, string> = {
  ember: 'bg-ember-600',
  mystic: 'bg-mystic-500',
  moss: 'bg-moss-500',
};

interface StatBarProps {
  label: string;
  valor: number;
  max: number;
  color?: BarColor;
}

export function StatBar({ label, valor, max, color = 'ember' }: StatBarProps) {
  const pct = max > 0 ? Math.max(0, Math.min(100, (valor / max) * 100)) : 0;
  return (
    <div>
      <div className="flex justify-between text-xs font-ui text-ash-400 mb-1">
        <span className="uppercase tracking-wider">{label}</span>
        <span className="tabular-nums">
          {valor}/{max}
        </span>
      </div>
      <div className="h-2 bg-ash-900 rounded overflow-hidden">
        <div
          className={cn('h-full transition-[width] duration-300 ease-out', COLORS[color])}
          style={{ width: `${pct}%` }}
          role="progressbar"
          aria-valuenow={valor}
          aria-valuemin={0}
          aria-valuemax={max}
          aria-label={label}
        />
      </div>
    </div>
  );
}
